module.exports = __webpack_public_path__ + "static/img/giovanni-ribeiro-B1hX9TE7HDY-unsplash_thumb.3dd7fa6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/giovanni-ribeiro-B1hX9TE7HDY-unsplash_thumb.png
// module id = v4u9
// module chunks = 4